import { AttachmentSummary } from "@/types/Attachment";
import { IconUser, IconUsers } from "@tabler/icons-react";
import { useNavigate as useRouter, useParams } from "react-router-dom";
import React from "react";

type TCCAttachmentsProps = {
  value: AttachmentSummary[];
  isEditing: boolean;
};

export const TCCAttachments: React.FC<TCCAttachmentsProps> = ({
  value,
  isEditing,
}) => {
  const router = useRouter();
  const { eventId = "" } = useParams<{ eventId: string }>();

  if (isEditing) return <></>;

  const summaries = value || [];

  if (summaries.length === 0) {
    return <></>;
  }

  const handleClick = (attachmentId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    router(`/event/${eventId}/attachments?attachmentId=${attachmentId}`);
  };

  return (
    <div className="flex flex-wrap gap-1">
      {summaries.map((s) => (
        <span
          key={s.attachmentId}
          onClick={(e) => handleClick(s.attachmentId, e)}
          className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md surface-tertiary border border-transparent body-3-medium font-secondary cursor-pointer hover:surface-quaternary hover:border hover:outline-tertiary hover:shadow-sm transition-all"
        >
          {s.assignmentType === "GENERAL" ? (
            <IconUsers size={12} />
          ) : (
            <IconUser size={12} />
          )}
          {s.name}
        </span>
      ))}
    </div>
  );
};
